import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedTag = ({
  id = '',
  values = null,
  tagName = 'span',
  className = '',
  onClick = () => {},
  ...rest
}) => {
  const Tag = tagName;
  return (
    <FormattedMessage id={id} values={values}>
      {text => (
        <Tag className={className} onClick={onClick} {...rest}>
          {text}
        </Tag>
      )}
    </FormattedMessage>
  );
};

export default FormattedTag;
